<template>
  <div>
    <nurse-table
      :canDelete="true"
      viewRoute="ClinicNurseDetails"
      :canCreate="true"
      viewDetailRoute="ClinicNurseDetailView"
      createRoute="ClinicNurseCreate"
    />
  </div>
</template>

<script>
import nurseTable from '../../components/nurses/nurseTable.vue';

export default {
  components: {
    nurseTable,
  },
  data: () => ({}),
};
</script>
